@if (props()) {
  @switch (type()) {
    @case (IconTypes.MaterialIcon) {
      <div class="material-icons" [style]="style()">{{ path() }}</div>
    }

    @case (IconTypes.SystemIcon) {
      <div [style]="style()" class="system-icon">
        <i [class]="'icon ' + path()"></i>
      </div>
    }

    @default {
      <img [src]="path()" [style]="style()" />
    }
  }
}
